import { render, staticRenderFns } from "./ProjPickEdit.vue?vue&type=template&id=130e6a9c"
import script from "./ProjPickEdit.vue?vue&type=script&lang=js"
export * from "./ProjPickEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports